import { homeHeroImages } from "@/data/home-hero-images";
import { VIDEO_URLS } from "@/data/videos";
import s from "./style.module.css";
// State
<let/isVisible=null as boolean | null>
<let/reduceMotion=false>
<let/systemPaused=true>
<let/userPaused=undefined as boolean | undefined>
// Derived
<const/showButton=(isVisible !== null ? `${isVisible}` : undefined)>
<const/paused=(userPaused ?? systemPaused)>
<const/poster=(
    reduceMotion ? VIDEO_URLS.homeHero.posterPRM : VIDEO_URLS.homeHero.poster
)>

<div/scrollRef class=s.scroll>
    <div class=s.sticky>
        <div class=s.container>
            <for|src, i| of=homeHeroImages>
                <div/cardRef class=s.card>
                    <img/imageRef src=src alt="">
                    <if=i === 0>
                        <video/videoRef
                            src=(VIDEO_URLS.homeHero.src)
                            poster=poster
                            muted
                            loop
                            playsinline
                            data-user-paused=`${userPaused}`
                            onPlay() {
                                systemPaused = false;
                            }
                            onPause() {
                                systemPaused = true;
                            }/>
                        <play-button
                            aria-label=`${paused ? "Resume" : "Pause"} video`
                            paused=paused
                            visible=reduceMotion || isVisible
                            class=s.button
                            onClick() {
                                if (paused) videoRef().play();
                                else videoRef().pause();

                                userPaused = videoRef().paused;
                            }/>
                    </if>
                </div>
                <script>
                    const prm = window.matchMedia(
                        "(prefers-reduced-motion: reduce)",
                    ).matches;
                    reduceMotion = prm;
                    const video = cardRef().querySelector("video");
                    if (video) {
                        systemPaused = video.paused;
                        const observer = new IntersectionObserver(
                            ([entry]) => {
                                const isUserPaused =
                                    video.dataset.userPaused === "true";
                                if (
                                    !isUserPaused &&
                                    !prm &&
                                    entry.isIntersecting
                                ) {
                                    video.play();
                                } else if (!video.paused) {
                                    video.pause();
                                }
                            },
                            {
                                threshold: 0,
                                rootMargin: "0px 0px -99% 0px",
                            },
                        );
                        observer.observe(scrollRef());
                        $signal.onabort = () => {
                            if (!observer) return;
                            observer.unobserve(scrollRef());
                            observer.disconnect();
                        };
                    }
                </script>
            </for>
        </div>
    </div>
    <div/scrollTargetRef class=s.scrollTarget/>
</div>
<script>
    const scrollTarget = scrollTargetRef();
    const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) isVisible = true;
        else isVisible = false;
    });
    observer.observe(scrollTarget);
    $signal.onabort = () => {
        observer.unobserve(scrollTarget);
        observer.disconnect();
    };
</script>
